import NewsSection from '@/sections/home/NewsSection'
import { useNewsListQuery } from '@queries/home/homeQueries.js'
import { WidgetFrame } from '../components/WidgetFrame'

const NewsWidgetPage = () => {
  const { data: newsData } = useNewsListQuery({ page: 1, count: 5 })

  return (
    <WidgetFrame>
      <NewsSection data={newsData} isWidget />
    </WidgetFrame>
  )
}

export default NewsWidgetPage
